import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e8e302a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-meeting" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "meeting-info" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "upper-buttons" }
const _hoisted_6 = {
  key: 3,
  class: "next-steps"
}
const _hoisted_7 = { class: "next-title" }
const _hoisted_8 = { class: "blocks-container" }
const _hoisted_9 = { class: "download" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, null, -1))
const _hoisted_11 = { class: "next-step-text" }
const _hoisted_12 = { class: "text-with-button" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { class: "delegate" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, null, -1))
const _hoisted_16 = { class: "next-step-text" }
const _hoisted_17 = { class: "text-with-button" }
const _hoisted_18 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopUpMeetingStatus = _resolveComponent("PopUpMeetingStatus")!
  const _component_Assessment = _resolveComponent("Assessment")!
  const _component_Feedback = _resolveComponent("Feedback")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_Drawer = _resolveComponent("Drawer")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.meetingStatus.status !== _ctx.statusType.none)
      ? (_openBlock(), _createBlock(_component_PopUpMeetingStatus, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isMobileScreen && _ctx.popup.opened && _ctx.popup.section === 'device-permission')
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 1,
          class: "popup-assess",
          title: _ctx.t('feedback.assessment.title'),
          onClose: _ctx.close
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!_ctx.assessed)
                ? (_openBlock(), _createBlock(_component_Assessment, {
                    key: 0,
                    "onUpdate:assessment": _cache[0] || (_cache[0] = ($event: any) => (_ctx.assessed = true))
                  }))
                : _createCommentVNode("", true),
              (_ctx.assessed)
                ? (_openBlock(), _createBlock(_component_Feedback, {
                    key: 1,
                    "onUpdate:closepopup": _ctx.close
                  }, null, 8, ["onUpdate:closepopup"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["title", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isMobileScreen)
      ? (_openBlock(), _createBlock(_component_Drawer, {
          key: 2,
          showClose: true,
          title: _ctx.t('feedback.assessment.title'),
          maxHeight: "530px"
        }, {
          default: _withCtx(() => [
            (!_ctx.assessed)
              ? (_openBlock(), _createBlock(_component_Assessment, {
                  key: 0,
                  "onUpdate:assessment": _cache[1] || (_cache[1] = ($event: any) => (_ctx.assessed = true))
                }))
              : _createCommentVNode("", true),
            (_ctx.assessed)
              ? (_openBlock(), _createBlock(_component_Feedback, {
                  key: 1,
                  "onUpdate:closepopup": _ctx.close
                }, null, 8, ["onUpdate:closepopup"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Typography, {
          fontType: "header",
          fontSize: "600"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('left.title')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            class: "home-button",
            mode: "primary",
            width: "fill-container",
            onClick: _ctx.goHome
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('left.goHome')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "rejoin-button",
            mode: "secondary",
            width: "fit-content",
            onClick: _ctx.rejoin
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('left.rejoin')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_Button, {
          mode: "flat",
          width: "fill-container",
          onClick: _ctx.open
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('left.feedback')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (!_ctx.isMobilePlatform)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Typography, {
              fontType: "header",
              fontSize: "900"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('next.title')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Typography, {
                  class: "title",
                  fontType: "header",
                  fontSize: "600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('next.forDevelopers.title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Typography, {
                      fontSize: "16px",
                      fontColor: "var(--sui-gray-600)"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('next.forDevelopers.description')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_Button, {
                    mode: "secondary",
                    iconOnly: true,
                    icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic20-chevron-right', height: 20, width: 20 },
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLink("https://github.com/voximplant/solutions-videoconference")))
                  }, null, 8, ["icon"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_Typography, {
                  class: "title",
                  fontType: "header",
                  fontSize: "600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('next.forNotDevelopers.title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_Typography, {
                      fontSize: "16px",
                      fontColor: "var(--sui-gray-600)"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('next.forNotDevelopers.description')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_Button, {
                    mode: "secondary",
                    iconOnly: true,
                    icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic20-chevron-right', height: 20, width: 20 },
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openLink("https://voximplant.com/platform/video")))
                  }, null, 8, ["icon"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}